































































import { Vue, Component, Prop } from "vue-property-decorator";
import { Material, RoleEnum } from "../models";
import "../components/CustomPopup";

@Component
export default class MaterialList extends Vue {
    @Prop() private materials: Material[];
    private open: boolean = false;
    RoleEnum = RoleEnum;
}

Vue.component("mt-material-list", MaterialList);
